import React, { FC } from "react";
import { TabPanel as MuiTabPanel } from "@mui/lab";

type Props = React.ComponentProps<typeof MuiTabPanel>;

const TabPanel: FC<Props> = (props) => {
    return <MuiTabPanel {...props}/>
}

export default TabPanel;